module.exports = __webpack_public_path__ + "static/media/divino.47a40818.svg";